import Vue from 'vue'

const state = {
    status: '',
}

const getters = {}

const actions = {
    ftpServersRequest: async ({commit}) => {
        return new Promise((resolve, reject) => {
            commit('ftpServerRequest')
            Vue.axios.get('/api/ftp-servers')
                .then(result => {
                    commit('ftpServerSuccess')
                    resolve(result.data)
                })
                .catch(err => {
                    commit('ftpServerError');
                    reject(err)
                })
        })
    },

    ftpServerSaveRequest: async ({commit}, queries) => {
        const url = queries.id ? `/api/ftp-servers/${queries.id}` : '/api/ftp-servers';
        const method = queries.id ? 'put' : 'post';

        return new Promise((resolve, reject) => {
            commit('ftpServerRequest')
            Vue.axios[method](url, queries)
                .then(result => {
                    commit('ftpServerSuccess')
                    resolve(result.data)
                })
                .catch(err => {
                    commit('ftpServerError');
                    reject(err)
                })
        })
    },

    ftpServerDeleteRequest: async ({commit}, queries) => {
        const suffix = queries.purge ? '?purge=1' : '';

        return new Promise((resolve, reject) => {
            commit('ftpServerRequest')
            Vue.axios.delete(`/api/ftp-servers/${queries.id}${suffix}`)
                .then(result => {
                    commit('ftpServerSuccess')
                    resolve(result.data)
                })
                .catch(err => {
                    commit('ftpServerError');
                    reject(err)
                })
        })
    },

    /**
     * Sonde ce que la source sait donner comme dates.
     * Avec un id : sur le serveur enregistre. Sans : sur une config en cours de saisie.
     */
    ftpServerProbeRequest: async ({commit}, queries) => {
        const url = queries && queries.id
            ? `/api/ftp-servers/${queries.id}/probe`
            : '/api/ftp-servers/probe';

        return new Promise((resolve, reject) => {
            commit('ftpServerRequest')
            Vue.axios.post(url, queries || {})
                .then(result => {
                    commit('ftpServerSuccess')
                    resolve(result.data)
                })
                .catch(err => {
                    commit('ftpServerError');
                    reject(err)
                })
        })
    },

    /** Ce qui serait pris et ce qui serait ecarte, avant d'enregistrer. */
    ftpServerPreviewRequest: async ({commit}, queries) => {
        return new Promise((resolve, reject) => {
            commit('ftpServerRequest')
            Vue.axios.post(`/api/ftp-servers/${queries.id}/preview`, queries)
                .then(result => {
                    commit('ftpServerSuccess')
                    resolve(result.data)
                })
                .catch(err => {
                    commit('ftpServerError');
                    reject(err)
                })
        })
    },

    ftpServerTestRequest: async ({commit}, queries) => {
        return new Promise((resolve, reject) => {
            commit('ftpServerRequest')
            Vue.axios.post(`/api/ftp-servers/${queries.id}/test`)
                .then(result => {
                    commit('ftpServerSuccess')
                    resolve(result.data)
                })
                .catch(err => {
                    commit('ftpServerError');
                    reject(err)
                })
        })
    },

    ftpServerStatsRequest: async ({commit}, queries) => {
        return new Promise((resolve, reject) => {
            commit('ftpServerRequest')
            Vue.axios.get(`/api/ftp-servers/${queries.id}/stats`)
                .then(result => {
                    commit('ftpServerSuccess')
                    resolve(result.data)
                })
                .catch(err => {
                    commit('ftpServerError');
                    reject(err)
                })
        })
    },

    /** Promeut la config FTP inline d'un univers en serveur partage. */
    ftpServerPromoteRequest: async ({commit}, queries) => {
        return new Promise((resolve, reject) => {
            commit('ftpServerRequest')
            Vue.axios.post(`/api/sites/${queries.siteId}/promote-ftp`, queries)
                .then(result => {
                    commit('ftpServerSuccess')
                    resolve(result.data)
                })
                .catch(err => {
                    commit('ftpServerError');
                    reject(err)
                })
        })
    },
}

const mutations = {
    ftpServerRequest: (state) => {
        state.status = 'loading';
    },
    ftpServerSuccess: (state) => {
        state.status = 'success';
    },
    ftpServerError: (state) => {
        state.status = 'error';
    },
}

export default {
    state,
    getters,
    actions,
    mutations,
}
